export default {
  ar() {
    return {
      andManyMore: 'And many more...',
      emergencyRecall: 'Emergency services recall',
      homeEmergency: 'Home emergency',
      nonRefundableBooking: 'Non-refundable Booking',
      preExistingCondition: 'Pre-existing medical conditions',
      privateVehicleFailure: 'Private vehicle failure',
      publicTransportFailure: 'Public transport failure',
      recommended: 'Recommended',
      refundableBooking: 'Refundable Booking',
      relativeSickness: 'Immediate relative sickness',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Sickness, accident, injury'
    }
  },
  de() {
    return {
      andManyMore: 'Und viele mehr...',
      emergencyRecall: 'Rückruf von Notfalldiensten',
      homeEmergency: 'Notfall zu Hause',
      nonRefundableBooking: 'Nicht erstattungsfähige Buchung',
      preExistingCondition: 'Vorerkrankungen',
      privateVehicleFailure: 'Ausfall des Privatfahrzeugs',
      publicTransportFailure: 'Ausfall der öffentlichen Verkehrsmittel',
      recommended: 'Recommended',
      refundableBooking: 'Erstattungsfähige Buchung',
      relativeSickness: 'Krankheit eines unmittelbaren Familienangehörigen',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Krankheit, Unfall, Verletzung'
    }
  },
  en() {
    return {
      andManyMore: 'And many more...',
      emergencyRecall: 'Emergency services recall',
      homeEmergency: 'Home emergency',
      nonRefundableBooking: 'Non-refundable Booking',
      preExistingCondition: 'Pre-existing medical conditions',
      privateVehicleFailure: 'Private vehicle failure',
      publicTransportFailure: 'Public transport failure',
      recommended: 'Recommended',
      refundableBooking: 'Refundable Booking',
      relativeSickness: 'Immediate relative sickness',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Sickness, accident, injury'
    }
  },
  enGB() {
    return {
      andManyMore: 'And many more...',
      emergencyRecall: 'Emergency services recall',
      homeEmergency: 'Home emergency',
      nonRefundableBooking: 'Non-refundable Booking',
      preExistingCondition: 'Pre-existing medical conditions',
      privateVehicleFailure: 'Private vehicle failure',
      publicTransportFailure: 'Public transport failure',
      recommended: 'Recommended',
      refundableBooking: 'Refundable Booking',
      relativeSickness: 'Immediate relative sickness',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Sickness, accident, injury'
    }
  },
  esMX() {
    return {
      andManyMore: 'And many more...',
      emergencyRecall: 'Emergency services recall',
      homeEmergency: 'Emergencia en el hogar',
      nonRefundableBooking: 'Non-refundable Booking',
      preExistingCondition: 'Pre-existing medical conditions',
      privateVehicleFailure: 'Private vehicle failure',
      publicTransportFailure: 'Fallo del Transporte Público',
      recommended: 'Recommended',
      refundableBooking: 'Refundable Booking',
      relativeSickness: 'Immediate relative sickness',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Enfermedad, Accidente, Lesión'
    }
  },
  fr() {
    return {
      andManyMore: 'Et bien plus encore...',
      emergencyRecall: 'Rappel des services d\'urgence',
      homeEmergency: 'Services d\'urgence à domicile',
      nonRefundableBooking: 'Réservation non remboursable',
      preExistingCondition: 'Affections préexistantes',
      privateVehicleFailure: 'Défaillance d\'un transport privé',
      publicTransportFailure: 'Défaillance d\'un transport en commun',
      recommended: 'Recommended',
      refundableBooking: 'Réservation remboursable',
      relativeSickness: 'Maladie d\'un parent proche',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Maladie, accident, blessure'
    }
  },
  it() {
    return {
      andManyMore: 'E tanti altri ancora…',
      emergencyRecall: 'Richiamo dei servizi di emergenza',
      homeEmergency: 'Emergenza domestica',
      nonRefundableBooking: 'Prenotazione non rimborsabile',
      preExistingCondition: 'Condizioni mediche preesistenti',
      privateVehicleFailure: 'Guasto a veicolo privato',
      publicTransportFailure: 'Problemi di trasporto pubblico',
      recommended: 'Recommended',
      refundableBooking: 'Prenotazione rimborsabile',
      relativeSickness: 'Malattia di parente prossimo',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Malattia, infortunio, lesioni'
    }
  },
  ja() {
    return {
      andManyMore: 'などなど...',
      emergencyRecall: '緊急サービスについて',
      homeEmergency: '自宅の緊急事態',
      nonRefundableBooking: '返金不可の予約',
      preExistingCondition: '事前の健康状態',
      privateVehicleFailure: '自家用車の不具合',
      publicTransportFailure: '公共交通機関の不具合',
      recommended: 'Recommended',
      refundableBooking: '返金可能な予約',
      relativeSickness: '近親者の病気',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: '病気、事故、怪我'
    }
  },
  pl() {
    return {
      andManyMore: 'And many more...',
      emergencyRecall: 'Emergency services recall',
      homeEmergency: 'Home emergency',
      nonRefundableBooking: 'Non-refundable Booking',
      preExistingCondition: 'Pre-existing medical conditions',
      privateVehicleFailure: 'Private vehicle failure',
      publicTransportFailure: 'Public transport failure',
      recommended: 'Recommended',
      refundableBooking: 'Refundable Booking',
      relativeSickness: 'Immediate relative sickness',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: 'Sickness, accident, injury'
    }
  },
  zhCN() {
    return {
      andManyMore: '更多详情……',
      emergencyRecall: '紧急服务召回',
      homeEmergency: '家庭急救护理',
      nonRefundableBooking: '不可退款的预订',
      preExistingCondition: '过往病史',
      privateVehicleFailure: '私家车故障',
      publicTransportFailure: '公共交通故障',
      recommended: 'Recommended',
      refundableBooking: '可退款预订',
      relativeSickness: '直接相关疾病',
      upgradeStatement: 'Upgrade your booking and receive a 100% refund (up to $15,000 USD) if you cannot attend for one of the many reasons in our Terms and Conditions <a href=" https://www.refundable.me/" target="_blank">here</a>, which you accept when you select a Refundable Booking',
      unexpectedPersonalProblem: '疾病、意外、伤害'
    }
  }
}
